/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */
import OcrConfirmation from 'vcomponents/ocr/OcrConfirmation.vue';
import OcrListLegacy from 'vcomponents/ocr/OcrListLegacy.vue';

export default [
    {
        path: '/ocr/list/:linkedtype',
        name: 'ocr.list',
        meta: {
            menuId: 'purchases',
        },
        component: OcrListLegacy,
        props: true,
    },
    {
        path: '/rest/ocr/create/:linkedtype',
        name: 'legacy.ocr.create',
    },
    {
        path: '/ocr/confirmation',
        name: 'ocr.confirmation',
        component: OcrConfirmation,
        props: true,
    },
];
